// Adding the media of a public post on X as files of this drive.
//
// The API reads the post, since X only serves a post's description to its own embed pages, and
// says where each photo and video is. The browser fetches those itself: X's media hosts let any
// site read them. Each one becomes a File named as the API named it, ready for the upload path
// like a file picked from disk.
//
// "isPostLink" is a first look, for reading a link as soon as one is pasted rather than on every
// keystroke. The API checks the link again, and is the one that decides.

const POST_LINK = /^(?:https?:\/\/)?(?:www\.|mobile\.)?(?:x|twitter)\.com\/(?:\w{1,15}|i)\/status(?:es)?\/\d{1,20}(?:[/?#]\S*)?$/i

const TYPES = {photo: 'image/jpeg', video: 'video/mp4', gif: 'video/mp4'}

export const isPostLink = text => POST_LINK.test(text.trim())

// X ends a post's text with the short link to its own media, which says nothing once the media
// are shown.
export const postText = text => text.replace(/\s*https:\/\/t\.co\/\w+\s*$/, '')

export const postedOn = postedAt => {
  const date = new Date(postedAt)

  if (Number.isNaN(date.getTime())) return ''

  return date.toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
}

export const runtime = durationMs => {
  const seconds = Math.round(durationMs / 1000)

  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`
}

/**
 * One photo or video, as a File. Rejects when X won't hand it over.
 *
 * Sent without a referrer: X's video host refuses a request that names another site as where it
 * came from, though it lets any site read the video otherwise.
 */
export const fetchMedia = async ({url, filename, kind}) => {
  const response = await fetch(url, {referrerPolicy: 'no-referrer'})

  if (!response.ok) throw new Error(`X answered ${response.status} for ${filename}`)

  const body = await response.blob()

  return new File([body], filename, {type: body.type || TYPES[kind]})
}
